export * from './envs';

export const FBC_PARAM = '_fbc';
export const FBP_PARAM = '_fbp';
export const TIKTOK_TTP = '_ttp';
export const GOOGLE_ONE_LINK =
  'https://family-locator.onelink.me/YibT/p01jpab1';
export const META_ONE_LINK = 'https://familylocator.onelink.me/JQls/06e4mm76';
export const TIKTOK_ONE_LINK = '';
export const PRODUCT_NAME = 'Family Locator';
export const COOKIE_UUID_KEY = 'userUuid';
export const GOOGLE_ADS_CONVERSION_ID = 'gQppCOWhjM8bEJqgyZQB';
export const GOOGLE_ADS_ACCOUNT_ID = '9203700535-IOS';
